// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-content {
  padding-top: 10px;
  padding-bottom: 1em;
}

.dialog-msg {
  margin-top: -20px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/message-box/message-box.scss"],"names":[],"mappings":"AAAA;EACG,iBAAA;EACA,mBAAA;AACH;;AAEA;EACG,iBAAA;AACH","sourcesContent":[".mat-dialog-content {\n   padding-top: 10px;\n   padding-bottom: 1em;\n}\n\n.dialog-msg {\n   margin-top: -20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
